// client/hooks/navigation.ts
import { routingState } from "@adornis/router/client/routing-state.js";
import { currentUser } from "@adornis/users/client/currentUser.js";
import { debounceTime, distinctUntilChanged } from "rxjs";
import { NavigationEventlog } from "../../db/hooks/navigation-eventlog.js";
import { EVENTLOGSETTINGS, defaultTrackingSettings } from "./util.js";
routingState.path$.pipe(distinctUntilChanged(), debounceTime(0)).subscribe(async () => {
  if (!EVENTLOGSETTINGS || EVENTLOGSETTINGS.getValue().navigation === void 0 && !defaultTrackingSettings.navigation || EVENTLOGSETTINGS.getValue().navigation === false)
    return;
  const user = await currentUser().result;
  void new NavigationEventlog({
    userID: user?._id
  }).create();
});
